/**
 * @module datetime/formatDate
 * @since 2.4.0
 */

export const DEFAULT_YEAR_FORMAT = 'numeric';
export const DEFAULT_MONTH_FORMAT = 'short';
export const DEFAULT_DAY_FORMAT = 'numeric';
export const DEFAULT_LOCALE = 'en';

/**
 * Generates a date string according to formatting options.
 * @param   {Date} datetime The date to format.
 * @param   {String} [options.year='numeric'] Set to "false" to omit year from output
 * @param   {String} [options.month='short'] Set to "false" to omit month from output
 * @param   {String} [options.day='numeric'] Set to "false" to omit day from output
 * @param   {String} [options.locale='en']
 * @returns {String} representation of the date based on formatting options
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
 */
export function formatDate(date, { year = DEFAULT_YEAR_FORMAT, month = DEFAULT_MONTH_FORMAT, day = DEFAULT_DAY_FORMAT, locale = DEFAULT_LOCALE } = {}) {
    if (!(date instanceof Date)) {
        throw new TypeError('formatDate expects \'date\' argument to be instance of Date');
    }

    year = year || undefined;
    month = month || undefined;
    day = day || undefined;

    const formatter = new Intl.DateTimeFormat(locale, { month, year, day });
    return formatter.format(date);
}
